import React, { useEffect, useState } from 'react'
import Grid from "@mui/material/Grid"
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import SearchIcon from '@mui/icons-material/Search'
import { useGetGpsLogsQuery } from '../../store/services/reportsService'
import ElegantLoader from '../../Components/Loader'
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

const GpsDataLog = () => {
const gpsDataColumns = [
    { field: 'timestamp', header: 'Timestamp' },
    { field: 'rawData', header: 'Raw Data' }
];

    const [inputValue, setInputValue] = useState("")
    const [searchQuery, setSearchQuery] = useState("")
    const {data:gpsLogs,error,isLoading:gpsLogsLoading}=useGetGpsLogsQuery(searchQuery)

    const parseGpsData = (text) => {
        try {
            console.log('Raw data received:', text);
            const dataString = text.data;

            if (!dataString) {
                return [];
            }

            const parsedData = JSON.parse(dataString);
            console.log('Parsed JSON data:', parsedData);

            const transformedData = parsedData.map(item => ({
                id: item.pk,
                timestamp: item.fields.timestamp,
                rawData: item.fields.raw_data,
                gpsDataArray: item.fields.raw_data.split(',')
            }));
            return transformedData;
        } catch (error) {
            console.error('Error parsing GPS data:', error);
            return [];
        }
    }

    const handleInputChange = (e) => {
        setInputValue(e.target.value)
    }

    const handleSearch = (event) => {
        event.preventDefault();
        setSearchQuery(inputValue);
        console.log('Searching for IMEI:', inputValue);
    };
    

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <form onSubmit={handleSearch}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                label="Search by IMEI"
                                value={inputValue}
                                onChange={handleInputChange}
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                startIcon={<SearchIcon />}
                                size="small"
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>
            <Grid item xs={12}>
                {gpsLogsLoading ? (
                    <ElegantLoader variant="circular" text="Loading..." transparent/>
                ) : error ? (
                    <div>Error loading data: {error.message || 'Unknown error'}</div>
                ) : (
                    (() => {
                        const parsedRows = parseGpsData(gpsLogs);
                        console.log('Final rows for table:', parsedRows);
                        return (
                            <Box sx={{ mt: 1 }}>
                                <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
                                    GPS Data Logs
                                </Typography>
                                <Paper elevation={1} sx={{ overflow: 'hidden' }}>
                                    <TableContainer>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ 
                                                        width: '200px', 
                                                        fontWeight: 600, 
                                                        backgroundColor: '#f5f5f5',
                                                        padding: '12px 16px'
                                                    }}>
                                                        Timestamp
                                                    </TableCell>
                                                    <TableCell sx={{ 
                                                        fontWeight: 600, 
                                                        backgroundColor: '#f5f5f5',
                                                        padding: '12px 16px'
                                                    }}>
                                                        Raw Data
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {parsedRows.map((row, index) => (
                                                    <TableRow key={row.id || index} hover>
                                                        <TableCell sx={{ 
                                                            width: '200px', 
                                                            padding: '8px 16px',
                                                            borderRight: '1px solid #e0e0e0'
                                                        }}>
                                                            {row.timestamp}
                                                        </TableCell>
                                                        <TableCell sx={{ 
                                                            padding: '8px 16px',
                                                            wordBreak: 'break-all'
                                                        }}>
                                                            {row.rawData}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            </Box>
                        );
                    })()
                )}
            </Grid>
        </Grid>
    )
}

export default GpsDataLog
